module.exports = __webpack_public_path__ + "static/img/ent-detail-67.0d42dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-67.jpg
// module id = Hcfy
// module chunks = 51